import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import { Box, Button, Paper, Typography } from '@mui/material';
import React from 'react';
import { ErrorBoundary } from 'react-error-boundary';

function ErrorBoundaryFallback({ name, error, resetErrorBoundary }) {
    console.error(`"${name}" error boundary caught an error:`, error);
    return (
        <Box
            sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                minHeight: 300,
                p: 4,
            }}
        >
            <Paper
                elevation={0}
                sx={{
                    display: 'flex',
                    alignItems: 'center',
                    flexDirection: 'column',
                    gap: 2,
                    p: 5,
                    maxWidth: 420,
                    textAlign: 'center',
                    border: 1,
                    borderColor: 'divider',
                    borderRadius: 3,
                }}
            >
                <ErrorOutlineIcon sx={{ fontSize: 56, color: 'error.main', mb: 1 }} />
                <Typography variant='h6' fontWeight={600}>
                    Something went wrong
                </Typography>
                <Typography variant='body2' color='text.secondary'>
                    Try refreshing the page. If the problem continues, please contact a maintainer.
                </Typography>
                <Button onClick={resetErrorBoundary} variant='contained' disableElevation sx={{ mt: 1 }}>
                    Reload content
                </Button>
            </Paper>
        </Box>
    );
}

/**
 * Wrapper around ErrorBoundary from 'react-error-boundary'.
 * @see https://www.npmjs.com/package/react-error-boundary
 */
export function CustomErrorBoundary({ name, children }) {
    return (
        <ErrorBoundary
            fallbackRender={({ error, resetErrorBoundary }) => (
                <ErrorBoundaryFallback name={name} error={error} resetErrorBoundary={resetErrorBoundary} />
            )}
        >
            {children}
        </ErrorBoundary>
    );
}
